import { Component, OnInit, SimpleChanges, ViewChild, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { GridService } from '../../../Shared/Services/grid.service';
import { UserService } from '../../../Shared/Services/user.service';
import {default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/CAT-Exception-Columns.json';
import {default as AggoOrderColumnsJSON} from 'app/Shared/Constant/Grid Column Names/AGGO-Columns.json';
import {default as TDETColumnsJSON} from 'app/Shared/Constant/Grid Column Names/TDET-Columns.json';
import {default as LegDetailsColumnsJSON} from 'app/Shared/Constant/Grid Column Names/LegDetails-Columns.json';
import {default as Timecombo} from 'app/Shared/Constant/TimeDropDown.json';
import { SharedHttpClientService } from '../../../Shared/Services/shared-http-client.service';
import { UrlsService } from '../../../Shared/Services/urls.service';
import { ConfirmationService,MessageService} from 'primeng/api';
import { Table, TableModule  } from "primeng/table";
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, LowerCasePipe, NgClass, CommonModule, NgStyle } from '@angular/common';
import { Util } from '../../../Shared/Constant/Util';
import { map, Subscription } from 'rxjs';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { EventTreeService } from 'app/Shared/Component/event-tree/event-tree.service';
import { DataService } from 'app/Shared/Services/data.service';
import { FieldDictionary } from '../finra-exception/field-dictionary.model';
import { ToastModule } from 'primeng/toast';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { SymbolPanelComponent } from 'app/Shared/Component/symbol-panel/symbol-panel.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDividerModule } from '@angular/material/divider';
import { MultiSelectModule } from 'primeng/multiselect';
import { EventConversionComponent } from 'app/Shared/Component/event-conversion/event-conversion.componenet';
import { EventTreeDialogComponent } from 'app/Shared/Component/event-tree/event-tree-dialog.componenet';
import { AuditTrailDialogComponent } from 'app/Shared/Component/audit-trail/audit-trail-dialog.componenet';
import { MultiLegEventComponent } from '../cat-roe-viewer/multileg-event/multileg-event.component';
import { NewROEEntryComponent } from 'app/Shared/Component/new-roe-entry/new-roe-entry.component';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { QuickSearchComponent } from "app/Shared/Component/quick-search/quick-search.component";
import { ViewFdidComponent } from 'app/Pages/ref-data-viewer/fdid-info/view-fdid/view-fdid.component';
import { DrawerModule } from 'primeng/drawer';
import { Select } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu';
import { GridCommonService } from 'app/Shared/Services/grid-common.service';

@Component({
    selector: 'app-cats-exception',
    imports: [ToastModule, FilterPanelComponent, SymbolPanelComponent, ConfirmDialogModule, CommonModule, MatProgressSpinner,
        TableModule, NgClass, ButtonModule, Select, DialogModule, MatStepperModule, DatePickerModule, MatDividerModule,ContextMenuModule,
        MultiSelectModule, EventConversionComponent, DrawerModule, EventTreeDialogComponent, AuditTrailDialogComponent,
        MultiLegEventComponent, NewROEEntryComponent, LowerCasePipe, FormsModule, MatTooltipModule, ExportToCSVSComponent, QuickSearchComponent, NgStyle, ToggleSwitchModule, ViewFdidComponent],
    templateUrl: './cats-exception.component.html',
    styleUrls: ['./cats-exception.component.scss']
})
export class CatsExceptionComponent implements OnInit, OnDestroy {

  @ViewChild(('dt')) dt!: Table;
  @ViewChild('cm') contextMenuItems!: ContextMenu;
  filterFieldDefaultValues: any = new Object();
  quickFilterArray: any = GridColumnsJSON["CAT-Exception-Quick-Search-Fields"];
  GridColumns: any = GridColumnsJSON["CAT-Exception-Grid-Columns"];
  exportGridColumns: any = [];
  dataset1: any[] = [];
  ApplicationName: any = '';
  ActiveSymbol: any;
  LastExecutionCATDate!: any[];
  SymbolsArray: any = [];
  CodesArray: any = [];
  DefaultFilterArray: any = [];
  multiLegEventArray: any = [];
  isFilterLabelReset: boolean = false;
  isResetGridlimit: boolean = false;
  isLoadingResults = true;
  tbldatamsg = "L o a d i n g . . . . .";
  Limit: any = { 'Start': '', 'End': '' };
  totalRecords: any;
  columnJson: any = [];
  cols: any = []
  filterCols: any = []
  rowsPerPageOptions: any = [];
  rowcount!: number;
  startLimit: any = 0;
  endLimit!: number;
  priviousRowCount!: number;
  pageNumber: any = 1;
  priviousStartLimit: any;
  View: boolean = false;
  Edit: boolean = false;
  displayDialog: boolean = false;
  Editviewcols: any = [];
  selectedRow: any = [];
  quickviewcols: any = [];
  EventType!: string;
  ResetLabel!: string;
  selectedRowLength!: number;
  selectedRowIndex: any;
  MultiEdit!: boolean;
  tempDataset: any = [];
  MultiEditRow: any = [];
  selectedRowJSONDataset: any[] = [];
  selectedRowOriginalJSON: any[] = [];
  msgs!: any[];
  FromDate: any = "";
  ExceptionCode: any = '';
  EditHeaderTittle!: string;
  CATFieldTypesArrayList: any = [];
  aggoOrdersCols: any;
  aggoOrdersData: any;
  handlingInstructionCols: any;
  handlingInstructionData: any
  tradeSideDetailsCols: any;
  legDetailsCols:any;
  tradeSideDetailsData: any;
  BooleanDropDown: any;
  TimeDropDown: any;
  newLabel!: string;
  isClickedOnce: boolean = false;
  checked: boolean = false;
  fdidChecked : boolean = false;
  givenNameForFDID: string = '';
  timeInForceValue: any = '';
  previousLimit: any = { 'Start': '', 'End': '' };
  private subscription!: Subscription;
  multiSelectedRow: Array<any> = [];
  correctCodeLength: number = 0;
  isShowConvertEventStepper: boolean = false;
  selectedTabIndex: number = 0;
  clearValueJSON: Array<any> = [];
  sortData:any = { field: '', order: 0};
  sortClickCounter: number = 0;
  defaultData: any;
  isAuditTrail!: boolean;
  rowDataforDialog: any;
  rowIndexForDialog!: number;
  public viewMultiLegEvent: boolean;
  eventList: any[] = [];
  originalEvent!: string[];
  selectedEventType:any;
  fieldDictionaryList!: FieldDictionary[];
  selectedID:any;
  selectedReportDate:any;
  selectedGroupName:any;
  selectedFileID :any;
  existingEventType: any;
  CATReporterIMID:any;
  public pageName:any;
  groupName:any;
  public displayNewROEDialog:boolean = false;
  displaySideBar:any=false;
  viewFDID:any=false;
  selectedFDIDDetails:any;
  isEnabledcaisFDIDService:boolean=false;
  selectedFDID:any;
  addCAISFailureCode=['3701', '3703', '3701', '3703', '3709'];
  ViewCAISFailureCode=['3702', '3704', '3706', '3708', '3710']


  constructor(
    private UrlsService: UrlsService,
    public UserService: UserService,
    private SharedHttpClientService: SharedHttpClientService,
    private gridService: GridService,
    private emitterService: EmitterService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private activatedRoute: ActivatedRoute,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    public constantService: ConstantService,
    public userService: UserService,
    private sortPipe: SortPipe,
    private datePipe: DatePipe,
    public eventTreeService:EventTreeService,
    public dataService: DataService,
    private router: Router,
    public commonColService:GridCommonService) {
    this.aggoOrdersCols = AggoOrderColumnsJSON;
    this.aggoOrdersData = [];
    this.tradeSideDetailsCols = TDETColumnsJSON;
    this.handlingInstructionCols = this.userService.handlingInstructionsJSON;
    this.legDetailsCols = LegDetailsColumnsJSON;
    this.tradeSideDetailsData = [];
    this.getFieldDictionary();
    this.viewMultiLegEvent = false;
    this.ApplicationName = this.constantService.getApplicationName();
    this.multiLegEventArray = this.gridService.getMultiLegEventTypes();
    let originalEvent = this.constantService.CONVERT_EVENT_LIST.replace(/ /g, '').split(',');
    for(let i=0;i<originalEvent.length;i++) {      
       this.eventList.push({label:originalEvent[i],value:originalEvent[i]});
    }
    this.isEnabledcaisFDIDService =this.userService.isEnabledcaisFDIDService;
  }

  ngOnInit(): void {
    this.exportGridColumns = this.GridColumns.filter((Obj: { excludeFromExport: any; }) => !Obj.excludeFromExport); // Remove Invisible Fields from Export File Field List 

    this.fieldDictionaryList = [];
    this.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.rowsPerPageOptions = this.constantService.DEFAULT_ROWSPERPAGEOPTION;
    this.endLimit = this.rowcount;
    this.Limit = { 'Start': '0', 'End': this.endLimit };
    this.totalRecords = this.rowcount;
    /* Dynamically Add Rows Per Page for CAT Exception Screen screen only */
    this.rowsPerPageOptions = [...this.constantService.DEFAULT_ROWSPERPAGEOPTION];

    this.BooleanDropDown = this.constantService.BOOLEAN_DROPDOWN;
    this.FromDate = this.activatedRoute.snapshot.paramMap.get('Date');
    this.ExceptionCode = this.activatedRoute.snapshot.paramMap.get('Code');
    this.multiLegEventArray = this.gridService.getMultiLegEventTypes();
    /*** Get Last CAT Execution date*/
    let todate: any;
    todate = this.UserService.CATLastExecutionDate;
    this.LastExecutionCATDate = [];
    if (todate != "" || todate != undefined || todate != null) {
      this.LastExecutionCATDate[0] = (todate);// Fromdate
      this.LastExecutionCATDate[1] = (todate);// Todate
      this.defaultFilter();
    }
    else {
      this.UserService.get_CAT_Last_ReportDate()
        .subscribe({
            next: (response:any) => {
            let jsondata: any = response;
            this.UserService.CATLastExecutionDate = jsondata.CATDate;
            todate = jsondata.CATDate;
            this.LastExecutionCATDate[0] = (todate);// Fromdate
            this.LastExecutionCATDate[1] = (todate);// Todate
            this.defaultFilter();
          }});
    }
    this.getColumns();
    this.getAggoOrdersColumns();
    this.getTDETColumns();
    this.getLegDetailsColumns();

    this.dataset1 = [];
    this.TimeDropDown = Timecombo;
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe({
      next: (value:any) => {
      if (value) {
        this.getData();
      }
    }});
    this.originalEvent = this.constantService.CONVERT_EVENT_LIST.replace(/ /g, '').split(',');

    // Inititalize Default Main Screen Filter Field Values
    const defaultEventTypeList: any = this.UserService.getDropDownList('type');
    const deaultEventTypeValues = defaultEventTypeList.map((rowObj: any) => rowObj.value);
    this.filterFieldDefaultValues = { type: deaultEventTypeValues };
    
    this.commonColService.init(this.cols, 'CAT-Exception');
  }
  ngAfterViewChecked(){
    this.isEnabledcaisFDIDService =this.userService.isEnabledcaisFDIDService;
  }

  getColumns() {
    let column: any = this.GridColumns;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.columnJson = this.gridService.getGridColumns(column);
      this.cols = this.gridService.getGridColumns(column);
      this.filterCols = this.cols;
    }
  }

  getAggoOrdersColumns() {
    let column: any = this.aggoOrdersCols;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.aggoOrdersCols = this.gridService.getGridColumns(column);
    }
  }

  getTDETColumns() {
    let column: any = this.tradeSideDetailsCols;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.tradeSideDetailsCols = this.gridService.getGridColumns(column);
    }
  }
  getLegDetailsColumns() {
    let column: any = this.legDetailsCols;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.legDetailsCols = this.gridService.getGridColumns(column);
    }
  }

  onRowSelect(value: any, index: any, rowData: any) {
    this.correctCodeLength = 0;
    this.selectedTabIndex = 0;
    this.clearValueJSON = [];
    this.selectedRow = this.dataService.checkRowExistanceInList(rowData, this.selectedRow, 'firmROEID'); // Check Row Object Existance in selected Row Object List
    this.multiSelectedRow = JSON.parse(JSON.stringify(this.selectedRow));
    this.isClickedOnce = false;
    if (this.selectedRow.length <= 1) {
      this.selectedRow = [];
      this.selectedRow[0] = (rowData)
    }
    this.fdidChecked = false;
    if (value == 'View') {
      this.getCATEditOriginalJSON(value, index, rowData);
    } else if (value == 'Edit') {
      this.getCATEditOriginalJSON(value, index, rowData);
    } else if (value == 'Delete') {
      this.deleteSelectedRows();
    } else if (value == 'RestoreDeleted') {
      this.restoreDeleteSelectedRows();
    }
    if (value == 'OrderID') {
      this.emitterService.isOrderViewerOpenCloseEvent.emit(
        {
          display: true,
          rowData: rowData,
          pageName: 'CAT-Exception'
        });
    }else if (value == 'EventTree') {
      this.eventTreeService.isDialogOpen=true;
      this.openTree(rowData);
    }
    else if (value == 'AuditTrail') {
      this.onAuditTrail(rowData);
    }
  }
  selectionChange(event: { selectedIndex: number; }) {
    this.selectedTabIndex = event.selectedIndex;
    this.isClickedOnce = false;
  }
  prepareJsonData(value: any, index: any, rowData: { orderID: any; orderKeyDate: any; quantity: any; originatingIMID: any; side: any; firmDesignatedID: any; accountHolderType: any; }) {
    this.selectedRowLength = Object.keys(this.selectedRow).length;
    if (this.selectedRowLength <= 1) {
      this.selectedRow = [];
      this.selectedRow[0] = (rowData)
    }
    this.selectedRowLength = Object.keys(this.selectedRow).length;
    this.quickviewcols = [];
    this.aggoOrdersData = [
      {
        'orderID': rowData.orderID,
        'orderKeyDate': rowData.orderKeyDate,
        'quantity': rowData.quantity,
        'originatingIMID': rowData.originatingIMID
      }
    ];
    this.tradeSideDetailsData = [
      {
        'orderKeyDate': rowData.orderKeyDate,
        'orderID': rowData.orderID,
        'side': rowData.side,
        'quantity': rowData.quantity,
        'firmDesignatedID': rowData.firmDesignatedID,
        'accountHolderType': rowData.accountHolderType,
        'originatingIMID': rowData.originatingIMID
      }
    ];
    let tempRow: any = this.selectedRow[0];
    this.EventType = '';
    this.EventType = tempRow.type;
    this.prepareQuickviewPanel();
    if (this.selectedRowLength == 1) // Single select row
    {
      if (value === 'Edit') {
        this.Edit = true;
      } else if (value === 'View') {
        this.View = true
      }

      let flag = tempRow.modifiedFlag;
      let ExceptionCode = tempRow.failureCode;
      if (this.EventType != "--" && this.EventType != "" && this.EventType != " " && this.EventType != null) {
        this.Editviewcols = [];

        this.tempDataset = this.cloneData(this.selectedRowJSONDataset[0]);/* *** set old data for backup */
        if (value == 'OrderID') {
          this.emitterService.isOrderViewerOpenCloseEvent.emit(
            {
              display: true,
              rowData: rowData,
              pageName: 'CAT-Exception'
            });
        }
        this.displayDialog = true;
      } else {
        if (value == 'View') {
          this.View = true;
        } else {
          let msginfo = 'Flag=' + flag;
          if (this.EventType == "--" || this.EventType == "" || this.EventType == " " || this.EventType == null)
            msginfo = 'Event Type=' + this.EventType;
          if (flag == 'D')
            msginfo = 'Flag=' + flag;
          this.messageService.add({ severity: 'warn', summary: 'Info Message', detail: 'Selected record is non editable please check ' + msginfo });
          this.displayDialog = false;
        }
      }
    }
    else if (this.selectedRowLength > 1) // multiselect rows
    {
      if (value == 'Edit') {
        this.MultiEditRow = [];
        this.validateMultiEdit(rowData);
      }
    }
  }
  getValueofField(fieldName: string, dropdownValue: any) {
    if (fieldName === 'type' && this.constantService.CONVERT_EVENT_JSON[this.selectedRowJSONDataset[0][fieldName]] != undefined) {
      this.isShowConvertEventStepper = true;
    } else if (fieldName === 'type' && this.constantService.CONVERT_EVENT_JSON[this.selectedRowJSONDataset[0][fieldName]] == undefined) {
      this.isShowConvertEventStepper = false;
    }
    if (this.View) {
      if (fieldName === 'buyDetails' || fieldName === 'sellDetails' || fieldName === 'clientDetails' || fieldName === 'firmDetails' || fieldName === 'legDetails'
        || fieldName === 'timeInForce' || fieldName === 'handlingInstructions' || fieldName === 'aggregatedOrders') { 
        return JSON.stringify(this.selectedRowJSONDataset[0][fieldName]);
      }
    }
    if (fieldName === 'handlingInstructions') {
      let obj = this.selectedRowJSONDataset[0][fieldName];
      let result = obj !== undefined && obj !== null ? Object.keys(obj).map(function (key) {
        return [(key), obj[key]];
      }) : [];
      this.handlingInstructionData = this.selectedRowJSONDataset[0][fieldName] !== undefined ? [this.selectedRowJSONDataset[0][fieldName]] : [{}];
      this.handlingInstructionCols = this.gridService.getGridColumnsHasValues(result);
      return this.selectedRowJSONDataset[0][fieldName];

    } else if (fieldName === 'reportDate' || fieldName === 'rsmsStatus' || fieldName === 'groupName'
    || fieldName === 'errorCodeList' || fieldName === 'createDate' || fieldName === 'updateDate' || fieldName === 'lastUpdatedBy') {
      if (fieldName === 'rsmsStatus') {
        return this.selectedRow[0].modifiedFlag
      }else if (fieldName === 'updateDate') {
        return this.selectedRow[0].createDate
    }else if (fieldName === 'lastUpdatedBy') {
      return this.selectedRow[0].user
    } else {
        return this.selectedRow[0][fieldName];
      }
    } else if (fieldName === 'timeInForce') {
      if (this.selectedRowJSONDataset[0][fieldName] !== undefined && this.selectedRowJSONDataset[0][fieldName] !== null) {
        this.timeInForceValue = Object.keys(this.selectedRowJSONDataset[0][fieldName]).length > 0 ? this.selectedRowJSONDataset[0][fieldName][this.getObjectKey(this.selectedRowJSONDataset[0][fieldName])] : this.selectedRowJSONDataset[0]['reportDate'].replaceAll("-", "");
        this.newLabel = Object.keys(this.selectedRowJSONDataset[0][fieldName]).length > 0 ? this.getObjectKey(this.selectedRowJSONDataset[0][fieldName]): dropdownValue[0]["value"];
      } else {
        this.newLabel = '';
      }
      

    } else if (fieldName === 'buyDetails' || fieldName === 'sellDetails' ||
      fieldName === 'clientDetails' || fieldName === 'firmDetails' || fieldName === 'timeInForce' || fieldName === 'handlingInstructions' || fieldName === 'legDetails' || fieldName === 'aggregatedOrders') {
      return this.selectedRowJSONDataset[0][fieldName] !== null && this.selectedRowJSONDataset[0][fieldName] !== undefined ? this.selectedRowJSONDataset[0][fieldName] : [{}];
    } else {
      return this.selectedRowJSONDataset[0][fieldName];
    }

  }

  cloneData(tempRow: any, action?: string) {
    this.Editviewcols = [];
    let len = Object.keys(this.quickviewcols).length;
    let FailureDescription = "";
    for (let i = 0; i < Object.keys(this.quickviewcols).length; i++) {
      let tempKeyName = this.quickviewcols[i].mappingkey;
      let isError = false;
      if (Util.isDefinedAndNotNull(tempKeyName)) {
        let error_code_object: any;
        error_code_object = this.UserService.getFieldDictionaryObject(tempKeyName);
        if (error_code_object) {
          let keyofValue = error_code_object["field_Name"];
          this.quickviewcols[i].datatype = error_code_object['data_Type'];
          this.Editviewcols[i] =
            {
              "ui_Field_Name": error_code_object["ui_Field_Name"],
              "field_Name": error_code_object["field_Name"],
              "default_Value": error_code_object["default_Value"],
              "value": this.getValueofField(keyofValue, error_code_object.dropdownvalue),
              "datatype": this.quickviewcols[i].datatype,
              "time": "00:00:00",
              "display": this.quickviewcols[i].display,
              "db_columnname": this.quickviewcols[i].db_columnname,
              "dropdowntype": error_code_object["dropdowntype"],
              "dropdownvalue": this.getFilteredValueOfField(error_code_object), // Search & Assign Dynamic DB stored Dropdown Values for Every Field
              "description": error_code_object["description"],
              "error_Code": error_code_object["error_Code"],
              "error_Code_Description": error_code_object["error_Code_Description"],
              "isException": isError,
              "isDisable": this.quickviewcols[i].disabled,
              "isMultiEdited" : false
            }
          let datatype: string = error_code_object["data_Type"];
          if (datatype == 'Choice') {
            this.Editviewcols[i].datatype = "Choice";
          }
        }
        else {
          this.Editviewcols[i] =
            {
              "ui_Field_Name": this.quickviewcols[i].ui_columnname,
              "field_Name": this.quickviewcols[i].mappingkey,
              "default_Value": "",
              "value": this.getValueofField(this.quickviewcols[i].mappingkey, this.quickviewcols[i].dropdownvalue),
              "datatype": this.quickviewcols[i].datatype,
              "time": "00:00:00",
              "display": this.quickviewcols[i].display,
              "db_columnname": this.quickviewcols[i].db_columnname,
              "dropdowntype": this.quickviewcols[i].dropdown,
              "dropdownvalue": this.quickviewcols[i].dropdownvalue,
              "description": "",
              "error_Code": "",
              "error_Code_Description": "",
              "isException": isError,
              "isDisable": this.quickviewcols[i].disabled,
            }
        }
      }
      if (action === 'mutiedit') {
        if (this.Editviewcols[i].ui_Field_Name === 'sellDetails' || this.Editviewcols[i].ui_Field_Name === 'buyDetails'
          || this.Editviewcols[i].ui_Field_Name === 'clientDetails' || this.Editviewcols[i].ui_Field_Name === 'firmDetails' 
          || this.Editviewcols[i].ui_Field_Name === 'legDetails' || this.Editviewcols[i].ui_Field_Name === 'aggregatedOrders') {
          this.Editviewcols[i]['value'] = [{}];
        } else if (this.Editviewcols[i].ui_Field_Name === 'timeInForce') {
          if (this.selectedRowJSONDataset[0][this.Editviewcols[i].ui_Field_Name] !== undefined &&
            this.selectedRowJSONDataset[0][this.Editviewcols[i].ui_Field_Name] !== null) {
            this.newLabel = this.getObjectKey(this.selectedRowJSONDataset[0][this.Editviewcols[i].ui_Field_Name]);
            this.timeInForceValue = undefined;
          }
        } else if (this.Editviewcols[i].ui_Field_Name === 'handlingInstructions') {
          this.handlingInstructionData = [{}];
          this.handlingInstructionCols = [];
        } else if (this.Editviewcols[i].ui_Field_Name === 'type' || this.Editviewcols[i].ui_Field_Name === 'CATReporterIMID' ||
          this.Editviewcols[i].ui_Field_Name === 'reportDate' || this.Editviewcols[i].ui_Field_Name === 'groupName') {
          this.Editviewcols[i]['value'] = this.Editviewcols[i]['value']
        } else {
          this.Editviewcols[i]['value'] = null;
        }
      }
    }
    return this.Editviewcols;
  }

  /* Get Filtered Dropdown Values for respective Fields (e.g. - side - ME* Event Types - B/SL/SS/SX & MO* Event Types - B/S) */
  getFilteredValueOfField(fieldObject: any) {
    let fieldOptions = fieldObject.dropdownvalue;
      if(fieldObject.field_Name === "side") {
        if(this.EventType.toLocaleLowerCase().startsWith("me")) {
          fieldOptions = fieldObject.dropdownvalue.filter((rowObj: any) => this.constantService.validSidesMEEventTypes.includes(rowObj.value));
        } else if (this.EventType.toLocaleLowerCase().startsWith("mo")) {
          fieldOptions = fieldObject.dropdownvalue.filter((rowObj: any) => this.constantService.validSidesMOEventTypes.includes(rowObj.value));
        }
      }
    return fieldOptions;
  }

  save() {
    this.isClickedOnce = true;
    this.givenNameForFDID = '';
    this.checked = false;
    let handlingObj: any;
   let  handlingArr: [target: object, ...sources: any[]] | { [x: number]: any; }[]= [];

    /* Form necessary Field Validation */
      if(!this.validateEssentialFormFields()) {
        return false;
      }
    /* End of Form necessary Field Validation */

    // to remove null value object from handling instruction.
    this.Editviewcols.filter((element: { field_Name: string; }, index: string | number) => {
      if (element.field_Name === 'handlingInstructions' && this.handlingInstructionData) {
        this.Editviewcols[index].value = null;    
        this.handlingInstructionCols.forEach((element: { header: string; }) => {
         let keys = Object.keys(this.handlingInstructionData[0]);
         if(this.handlingInstructionData[0] && Object.keys(this.handlingInstructionData[0]).length > 0 && keys.indexOf(element.header) >= 0)
         {
          handlingArr.push(this.userService.getHandlingInstructionValue(element,this.Editviewcols[index], this.handlingInstructionData[0]));
         }
        });
        if(handlingArr.length>0){
          handlingObj = Object.assign({}, ...handlingArr); // Array of obj into one obj
          }
          this.Editviewcols[index].value = this.handlingInstructionCols.length > 0 && handlingObj !== undefined ? this.removeNullValueObj(handlingObj) : null;         
      } else if (element.field_Name === 'timeInForce') {
        this.newLabel = this.newLabel === '' ? this.Editviewcols[index].dropdownvalue[0]["label"]: this.newLabel;
        this.Editviewcols[index].value = this.timeInForceValue ? { [this.newLabel]: (['GTT'].indexOf(this.newLabel) >= 0 ? this.timeInForceValue : JSON.parse(this.timeInForceValue)) } : undefined;
      } else if (element.field_Name === 'buyDetails' || element.field_Name === 'sellDetails' ||
        element.field_Name === 'clientDetails' || element.field_Name === 'firmDetails' ||
        element.field_Name === 'legDetails' || element.field_Name === 'aggregatedOrders') {
        this.Editviewcols[index].value = this.Editviewcols[index].value && Object.keys(this.removeNullValueObj(this.Editviewcols[index].value[0])).length === 0 ? null : this.Editviewcols[index].value;
      } else if(element.field_Name == 'firmDesignatedID' && this.Editviewcols[index].value !== null && this.Editviewcols[index].value !== undefined){
        this.Editviewcols[index].value =  this.Editviewcols[index].value.trim().length == 0 ? null : this.Editviewcols[index].value.trim(); 
      }
    })
    let tempRow = this.selectedRow[0];
    this.updateDataValidation(tempRow);
    if (this.selectedTabIndex === 0) {
      if (this.selectedRow.length > 1) {
        this.multiEditSave();
      } else {
        this.CallUpadteAPI();
      }
      this.selectedRow = [];
      this.displayDialog = false;
      this.newLabel = '';
    }
    return true;
  }

  validateEssentialFormFields() {
    let updatedJSONObject: any = {};

    this.Editviewcols.forEach((element:any, index:any) => {
      if (element.value !== null && element.value !== "" && element.value !== undefined) {
        updatedJSONObject[element.field_Name] = this.Editviewcols[index].value;
      }
    });

    /* Validation for Total Multileg Details */
      if(updatedJSONObject.hasOwnProperty('numberOfLegs') && (updatedJSONObject.numberOfLegs!==null && updatedJSONObject.numberOfLegs!==undefined && updatedJSONObject.numberOfLegs!=='' && updatedJSONObject.numberOfLegs!==0) && updatedJSONObject.hasOwnProperty('legDetails') && (updatedJSONObject.numberOfLegs !== updatedJSONObject.legDetails.length)) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter matching info for Leg Details and NumberOfLegs' });
        this.isClickedOnce = false;
        return false;
      } else if(updatedJSONObject.hasOwnProperty('numberOfLegs') && updatedJSONObject.numberOfLegs > 0 && updatedJSONObject.hasOwnProperty('legDetails') && !this.dataService.hasAnyEmptyObjectInObjectArray(updatedJSONObject.legDetails)) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter data in All Leg Details' });
        this.isClickedOnce = false;
        return false;
      }
    /* End of Validation for Total Multileg Details */

    /* Validation for AggoOrder Details */
      if(updatedJSONObject.hasOwnProperty('aggregatedOrders') && updatedJSONObject.aggregatedOrders.length > 0 && Object.keys(this.dataService.removeNullValueObj(updatedJSONObject.aggregatedOrders[0])).length > 0 && updatedJSONObject.hasOwnProperty('representativeInd') && (updatedJSONObject.representativeInd===null || updatedJSONObject.representativeInd===undefined || updatedJSONObject.representativeInd==='')) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter RepresentativeInd relevant with Aggo Details' });
        this.isClickedOnce = false;
        return false;
      } else if(updatedJSONObject.hasOwnProperty('aggregatedOrders') && updatedJSONObject.aggregatedOrders.length > 1 && !this.dataService.hasAnyEmptyObjectInObjectArray(updatedJSONObject.aggregatedOrders)) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter data in All Aggo Details' });
        this.isClickedOnce = false;
        return false;
      }
    /* End of Validation for AggoOrder Details */

    return true;
  }

  resetDefault() {
    let tempRow = this.selectedRowJSONDataset[0];
    this.cloneData(tempRow);
  }

  updateDataValidation(tempRow: any) {
    for (let i = 0; i < Object.keys(this.quickviewcols).length; i++) {
      let tempRow = this.selectedRow[0];
      this.Editviewcols

    }
  }
  singleEditFormateDatetime(datatype: string, type: string, i: string | number) {
    if (type == 'date') {
      let temp: string = this.datePipe.transform(this.Editviewcols[i].value, "yyyy-MM-dd") ?? "";
      let date: string = ((temp.replace("-", "")).replace("-", "")).replace("-", "");
      if (datatype == "DateTime") {
        let temptime: string = this.Editviewcols[i].time;
        if (temptime == undefined) {
          this.Editviewcols[i].value = date.concat("000000000");
        } else {
          let time: string = ((temptime.replace(":", "")).replace(":", "")).replace(":", "");
          this.Editviewcols[i].value = date.concat(time);
        }
      }
      else if (datatype == "Date" || datatype == "DateRange") {
        this.Editviewcols[i].value = date.concat("000000000");
      }
    } if (type == 'time') {
      let temp: string = this.Editviewcols[i].value;
      let date: string = temp.substring(0, 8);
      let temptime: string = this.Editviewcols[i].time;
      let time: string = ((temptime.replace(":", "")).replace(":", "")).replace(":", "");
      this.Editviewcols[i].value = date.concat(time);
    }
  }

  formatTime(value: string, i: string | number) {
    let temp: string = this.MultiEditRow[i].value;
    let date: string = temp.substring(0, 8);
    let temptime: string = value;
    let time: string = ((temptime.replace(":", "")).replace(":", "")).replace(":", "");
    this.MultiEditRow[i].value = date.concat(time);
  }
  formatDate(datatype: string, i: string | number) {
    let temp: string = this.datePipe.transform(this.MultiEditRow[i].value, "yyyy-MM-dd") ?? "";
    let date: string = ((temp.replace("-", "")).replace("-", "")).replace("-", "");
    if (datatype == "DateTime") {
      let temptime: string = this.MultiEditRow[i].time;
      if (temptime == undefined) {
        this.MultiEditRow[i].value = date.concat("000000000");
      } else {
        let time: string = ((temptime.replace(":", "")).replace(":", "")).replace(":", "");
        this.MultiEditRow[i].value = date.concat(time);
      }
    }
    else if (datatype == "Date" || datatype == "DateRange") {
      this.MultiEditRow[i].value = date.concat("000000000");
    }
  }
  getCATEditOriginalJSON(value: any, index: any, rowData: any) {
    this.selectedRowOriginalJSON = JSON.parse(rowData.originalJSON.replace(/'/g, '"'));
    this.selectedRowJSONDataset[0] = this.selectedRowOriginalJSON;
    let Data = {
      "mpid": this.UserService.getActiveMPID(),
      "groupName": rowData['groupName'],
      'reportDate': rowData['reportDate'],
      'firmROEID': rowData['firmROEID'],
      'pageName': "CAT-Exception",
      'eventType': rowData['type'],
      "fileID": this.selectedRow[0].fileID != null ? this.selectedRow[0].fileID : 0,
    };

    this.SharedHttpClientService.post(this.UrlsService.setAPIURl(APIURL.CAT_Exception_Get_OriginalJSON), Data)
      .pipe(map((response: Response) => {
        return response;
      })).subscribe({
        next: (dataset:any) => {
        let data: any = dataset;

        if (data.Data.length > 0) {
          this.selectedRowJSONDataset[0] = JSON.parse((data.Data[0].json).replace(/'/g, '"'));
        }
        this.prepareJsonData(value, index, rowData);
      },
       error: (err: HttpErrorResponse) => {
          this.prepareJsonData(value, index, rowData);
      }});

  }
  multiEditSave() {
    this.isLoadingResults= true;
    let multiEditPayload = {
      user: this.UserService.getUserName(),
      mpid: this.UserService.getActiveMPID(),
      updatedJSON: this.removeNoValueFieldsFromEditviewcols(),
      firmROEIDList: this.getFirmRowIdsOfMultiSelectedRows()
    }
    let msg = '';
    msg = 'Do you want to save changes for ' + this.correctCodeLength + ' records?';
    this.confirmationService.confirm({
      message: msg,
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button",

      accept: () => {
        this.SharedHttpClientService.post(this.UrlsService.setAPIURl(APIURL.CAT_Exception_MultiEdit), multiEditPayload)
          .pipe(map((response: Response) => {
            return response;
          })).subscribe({
            next: (Element:any) => {
            this.tempDataset = [];
            this.Edit = false;
            this.isClickedOnce = false;
            this.handlingInstructionData = [];
            this.messageService.add({ severity: 'success', summary: 'Update Success Message', detail: 'Record Updated Successfully' });
            this.getData();
          },
          error: (err: HttpErrorResponse) => {
              this.messageService.add({ severity: 'error', summary: 'Update', detail: 'Record Update Failed!' });
              this.isClickedOnce = false;
              this.isLoadingResults= false;
            }});
      }
    });
  }
  getFirmRowIdsOfMultiSelectedRows() {
    const firmROEID: Array<any> = []
    this.multiSelectedRow.forEach(row => {
      firmROEID.push(row.firmROEID.toString());
    });
    return firmROEID;
  }
  removeNoValueFieldsFromEditviewcols() {
    let object: any = {};
    this.Editviewcols.forEach((element: { field_Name: string; value: string | null; }, index: string | number) => {
      if(element.field_Name !="type" && element.field_Name !="groupName") 
        if (element.value !== null && element.value !== "" && element.value !== undefined) {
          object[element.field_Name] = this.Editviewcols[index].value;
        }
    });
    if(this.clearValueJSON.length >= 1) {
      this.clearValueJSON.forEach((element)=> {
        object[element.field_Name] = "";
      });
      /* Remove Blank TimeInForce Value from Updated JSON Object */
      if(object.timeInForce === undefined || object.timeInForce === "" || object.timeInForce === null) {
        delete object.timeInForce;
      }
    }
    return object;
  }
  CallUpadteAPI() {
    /* *** Update API Call */
    this.isLoadingResults= true;
    let object: any = {};
    let tempRow = this.selectedRowJSONDataset[0];

    this.Editviewcols.forEach((element: { value: string | null; field_Name: string | number; }, index: string | number) => {
      if (element.value !== null && element.value !== "" && element.value !== undefined) {
        object[element.field_Name] = this.Editviewcols[index].value;
        tempRow[element.field_Name] = this.Editviewcols[index].value;
      }
    });

    let Data = {
      "P_CATROWID": this.selectedRow[0].rowID != null ? this.selectedRow[0].rowID.toString() : null,
      "P_FileID": this.selectedRow[0].fileID != null ? this.selectedRow[0].fileID : 0,
      "P_CATReporterIMID": this.selectedRow[0].CATReporterIMID,
      "P_CATSubmitterID": this.selectedRow[0].CATSubmitterID,
      "P_FileName": this.selectedRow[0].fileName.toString(),
      "P_GroupName": this.selectedRow[0].groupName.toString(),
      "P_ActionFlag": "U",
      "P_ActualValue": tempRow['actualValue'],
      "P_CreateDate": tempRow['createDate'],
      "P_Date": this.selectedRow[0].reportDate,
      "P_Destination": tempRow['destination'] != null ? tempRow['destination'].toString() : '',
      "P_EventTimestamp": tempRow['eventTimestamp'] + "",
      "P_FailureCode": tempRow['failureCode'] != null ? tempRow['failureCode'].toString() : '',
      "P_FailureDescription": tempRow['failureDescription'] != null ? tempRow['failureDescription'].toString() : '',
      "P_FirmROEID": tempRow['firmROEID'] != null ? tempRow['firmROEID'].toString() : '',
      "P_LastUpdate": tempRow['lastUpdate'] != null ? tempRow['lastUpdate'].toString() : '',
      "P_ManualFlag": tempRow['manualFlag'] != null ? tempRow['manualFlag'].toString() : '',
      "P_OrderID": tempRow['orderID'] != null ? tempRow['orderID'].toString() : '',
      "P_OriginalJSON": JSON.stringify(this.selectedRowOriginalJSON) + "",
      "P_UpdatedJSON": JSON.stringify(object) + "",
      "P_QuoteId": tempRow['quoteId'] != null ? tempRow['quoteId'].toString() : '',
      "P_QuoteMPID": tempRow['quoteMPID'] != null ? tempRow['quoteMPID'].toString() : '',
      "P_RoutedOrderID": tempRow['routedOrderID'] != null ? tempRow['routedOrderID'].toString() : '',
      "P_Session": tempRow['session'] != null ? tempRow['session'].toString() : '',
      "P_Severity": tempRow['severity'] != null ? tempRow['severity'].toString() : '',
      "P_Status": tempRow['status'] != null ? tempRow['status'].toString() : '',
      "P_SuggestedValue": tempRow['suggestedValue'] != null ? tempRow['suggestedValue'].toString() : '',
      "P_Symbol": tempRow['type'].startsWith("MO") == true ? tempRow['optionID'] : tempRow['type'].startsWith("ML") == true ? tempRow['underlying'] :tempRow['symbol'],
      "P_TradeId": tempRow['tradeId'] != null ? tempRow['tradeId'].toString() : '',
      "P_Type": tempRow['type'] != null ? tempRow['type'].toString() : '',
      "P_Price": tempRow['price'] != null ? tempRow['price'].toString() : '',
      "P_Side": tempRow['side'] != null ? tempRow['side'].toString() : '',
      "P_Quantity": tempRow['quantity'] != null ? tempRow['quantity'].toString() : '',
      "P_User": this.UserService.getUserName(),
    }
    this.SharedHttpClientService.post(this.UrlsService.setAPIURl(APIURL.CAT_Exception_Summary_Update), Data)
      .pipe(map((response: Response) => {
        return response;
      }))
      .subscribe({
        next: (element:any) => {
        let data: any = element;
        if (data == "Update Failed"){
          this.messageService.add({ severity: 'error', summary: 'Update Failed Message', detail: 'Record Update Failed!' });
        }else{
          this.messageService.add({ severity: 'success', summary: 'Update Success Message', detail: 'Record Updated Successfully' });
        }
          if (data == "Updated Successfully") {
          tempRow = this.selectedRowOriginalJSON;
          tempRow['modifiedFlag'] = 'U';
          this.selectedRow[0] = tempRow;
          this.tempDataset = [];
          this.Edit = false;
          this.isClickedOnce = false;
          this.handlingInstructionData = [];
          this.messageService.add({ severity: 'success', summary: 'Update Success Message', detail: 'Record Updated Successfully' });
        }
        this.Edit = false;
        this.getData();
      },
        error: (err: HttpErrorResponse) => {
          this.isLoadingResults= false;
          this.messageService.add({ severity: 'error', summary: 'Update', detail: 'Record Update Failed!' });
          alert(err);
          this.isClickedOnce = false;
        }});

  }

  CallDeleteAPI(Data: { P_selectedRows: any; P_Updated_By: any; }) {
    /* *** Delete API Call */
    this.SharedHttpClientService.postPlainText(this.UrlsService.setAPIURl(APIURL.CAT_Exception_Summary_Delete), Data)
      .pipe(map((response: Response) => {
        return response;
      }))
      .subscribe({
        next: (Element:any) => {
        let data: any = Element;
        if (data == "Delete Failed")
          this.messageService.add({ severity: 'error', summary: 'Delete Message', detail: 'Deleted Failed' });
        if (data == "Deleted Successfully") {
          this.messageService.add({ severity: 'success', summary: 'Delete Message', detail: 'Records are Deleted Successfully ' });
        }
        this.getData();
      },
        error: (err: HttpErrorResponse) => {
          this.isLoadingResults = false;
          this.messageService.add({ severity: 'error', summary: 'Delete Message', detail: 'Deleted Failed' });
        }});

  }
  CallRestoreDeleteAPI(Data: { P_selectedRows: any; P_Updated_By: any; }, rowdata: any[], tempRow: undefined, index: number) {
    /* *** Delete API Call */
    this.SharedHttpClientService.postPlainText(this.UrlsService.setAPIURl(APIURL.CAT_Exception_Summary_RestoreDelete), Data)
      .pipe(map((response: Response) => {
        return response;
      }))
      .subscribe({
        next: (Element:any) => {
        this.isLoadingResults = false;
        let data: any = Element;
        if (data == "Restore Deleted Record Failed")
          this.messageService.add({ severity: 'error', summary: 'Delete Message', detail: 'Restore Deleted Failed' });
        if (data == "Restore Deleted Successfully") {
          this.messageService.add({ severity: 'success', summary: 'Delete Message', detail: 'Restored Successfully ' });
          this.getData();
        }
        this.selectedRow = [];
      },
        error: (err: HttpErrorResponse) => {  
          this.messageService.add({ severity: 'error', summary: 'Delete Message', detail: 'Restore Deleted Failed' });
          this.isLoadingResults = false;
        }});

  }

  deleteSelectedRows() {
    let msg = '';
    if (this.selectedRow.length > 1)
      msg = 'Are you sure you want to permanently remove all exceptions?';
    else
      msg = 'Are you sure you want to permanently remove this exception?';
    this.confirmationService.confirm({
      message: msg,
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button",

      accept: () => {
        this.isLoadingResults = true
        let Data = {
          'P_selectedRows': this.selectedRow,
          "P_Updated_By": this.UserService.getUserName(),
        };
        this.CallDeleteAPI(Data);
      }
    });
    this.displayDialog = false;
    this.msgs = [];
  }

  restoreDeleteSelectedRows() {
    let msg = '';
    if (this.selectedRow.length > 1)
      msg = 'Are you sure that you want to Restore DELETED All?';
    else
      msg = 'Are you sure that you want to Restore DELETED?';
    this.confirmationService.confirm({
      message: msg,
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button",

      accept: () => {
        this.isLoadingResults = true
        let tempRow;
        let Data;
        let rowdata = [...this.dataset1];
          Data = {
            "P_selectedRows": this.selectedRow,
            "P_Updated_By": this.UserService.getUserName()
          };
          this.CallRestoreDeleteAPI(Data, rowdata, tempRow,0);
          this.displayDialog = false;
      }
    });
    this.displayDialog = false;
    this.msgs = [];
  }
  validateMultiEdit(rowData: any) {

    this.selectedRow.forEach((row: { type: any; failureCode: any; groupName: any; reportDate: any; }) => {
      if (this.selectedRow[0].type === row.type && this.selectedRow[0].failureCode === row.failureCode &&
        this.selectedRow[0].groupName === row.groupName && this.selectedRow[0].reportDate === row.reportDate) {
        this.correctCodeLength = this.correctCodeLength + 1
      } else {
        this.correctCodeLength = this.correctCodeLength - 1
      }
    });

    if (this.selectedRow.length === this.correctCodeLength) {
      this.Editviewcols = []
      this.selectedRow[0] = rowData;
      this.cloneData(this.selectedRow[0], 'mutiedit')
      this.Edit = true
    } else {
      this.Edit = false
      this.confirmationService.confirm({
        message: 'Selected records must have same Group, Report Date, Event type and Exception code',
        key: 'informationDialoge',
        icon: 'pi pi-exclamation-triangle', 
        rejectVisible: false,
        header: 'Information',
        acceptLabel: 'Ok',
        acceptIcon:'pi pi-check',
        acceptButtonStyleClass:"confirm-dialog-button",

        accept: () => {

        }
      });
    }
  }
  lookupRowStyleClass(rowData: { [x: string]: string; }) {
    if (rowData['modifiedFlag'] === 'U')
      return rowData['modifiedFlag'] === 'U' ? 'ui-widget-updated-row' : 'ui-widget-NoUpdated-row';
    else if (rowData['modifiedFlag'] === 'D')
      return rowData['modifiedFlag'] === 'D' ? 'ui-widget-deleted-row .ui-chkbox ' : 'ui-widget-NoUpdated-row';

    return 'ui-widget-NoUpdated-row';
  }
  prepareQuickviewPanel() {
    this.quickviewcols = [];
    this.quickviewcols=this.gridService.prepareQuickviewPanel(this.EventType.toLocaleUpperCase());
  }

  changePage(event: { first: any; rows: number; }) {
    this.startLimit = event.first;
    this.rowcount = event.rows;
    this.endLimit = this.startLimit + this.rowcount;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.priviousStartLimit = this.startLimit;
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;
    this.getData();
  }

  updateDefaultArray($event: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit("All"); // Reset Quick Symbol/Exception-Code Filter
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;
    this.dt.first = this.startLimit;

    this.getSymbols();
    this.getData();
  }

  clearQuickSearch($event: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit("All"); // Reset Quick Symbol/Exception-Code Filter
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;
    this.dt.first = this.startLimit;

    this.getSymbols();
    this.getData();
  }

  FilterEventClearSymbol(event: any) {
    this.isResetGridlimit = true;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.emitterService.ResetQuickFilterPanelEvent.emit("Symbol");
  }

  FilterEventClearCode(event: any) {
    this.isResetGridlimit = true;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.emitterService.ResetQuickFilterPanelEvent.emit("Code");
  }

  FilterApplyFilterEvent(event: any) {
    this.isResetGridlimit = true;
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.getSymbols();
    this.getData();
  }


  setActiveSymbolEvent(event: any) {
    this.ActiveSymbol = event;
    for (let i = 0; i < this.DefaultFilterArray.length; i++) {
      if (this.DefaultFilterArray[i].label.toLocaleLowerCase() == 'symbol') {
        this.DefaultFilterArray[i].values = this.ActiveSymbol;
        this.startLimit = 0;
        this.Limit.Start = 0;
        this.pageNumber = 1;
        this.dt.first = this.startLimit;
        this.totalRecords = 0;
        this.emitterService.ReloadQuickFilterPanelEvent.emit("true");
        this.getData();
      }
    }
  }

  setActiveCodeEvent(event: any) {
    let ActiveCode: number = event;
    for (let i = 0; i < this.DefaultFilterArray.length; i++) {
      if ((this.DefaultFilterArray[i].label).toLocaleLowerCase() == 'code') {
        this.DefaultFilterArray[i].values = ActiveCode;
        this.startLimit = 0;
        this.Limit.Start = 0;

        this.pageNumber = 1;
        this.dt.first = this.startLimit;
        this.emitterService.ReloadQuickFilterPanelEvent.emit("true");
        this.getData();
      }
    }
  }

  CloseEvent(event: any) {
    this.View = false;
    this.Edit = false;
    this.MultiEdit = false;
  }

  GridResetSymbolEvent(event: any) {
    this.isFilterLabelReset = true;
    this.startLimit = 0;
    ;
    this.Limit.Start = 0;
    this.pageNumber = 1;
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.dt.first = this.startLimit;
    this.isResetGridlimit = true;
    this.emitterService.ResetQuickFilterPanelEvent.emit('All');
  }

  GridChangeLimitEvent(event: any) {
    this.Limit = event;
    this.getData();
  }

  defaultFilter() {
    let todate = this.UserService.CATLastExecutionDate;
    let fromdate = this.UserService.catFirstExecutionDate;
    if (this.FromDate == ('Null') || this.FromDate == ('NULL')) {
      this.LastExecutionCATDate = [];
      this.LastExecutionCATDate.push(fromdate);// Fromdate
      this.LastExecutionCATDate.push(todate);// todate
      if (this.ExceptionCode == '0012')
        this.ExceptionCode = '';
    }
    else if (this.FromDate) {
      this.LastExecutionCATDate = [];
      this.LastExecutionCATDate.push(this.UserService.getFormatedDate(this.UserService.getyyyyMMddDateFormate(this.FromDate))); // FromDate
      this.LastExecutionCATDate.push(this.UserService.getFormatedDate(this.UserService.getyyyyMMddDateFormate(this.FromDate))); // Todate
    }
    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Date', 'columnname': 'eventTimestamp', 'filterby': '', 'values':  this.LastExecutionCATDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'type', 'columnname': 'type', 'filterby': 'IS', 'values': this.gridService.getEventsList(this.DefaultFilterArray, 'type'), 'time': '', 'datatype': 'skip', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'multiselect', 'dropdownvalue': this.CATFieldTypesArrayList },
      {
        isdefault: 'true',
        label: 'Rsms Status',
        columnname: 'modifiedFlag',
        filterby: 'IN',
        values: [],
        time: '',
        datatype: 'Array',
        disabled: 'true',
        dropdown: 'YES',
        dropdowntype: 'multiselect',
        dropdownvalue: this.constantService.rsmsStatusDropDwn,
      },
      { 'isdefault': 'true', 'label': 'Firm ROEID', 'columnname': 'firmROEID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Symbol', 'columnname': 'symbol', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Code', 'columnname': 'failureCode', 'filterby': '=', 'values': this.ExceptionCode, 'time': '', 'datatype': 'int', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Quantity', 'columnname': 'quantity', 'filterby': '=', 'values': '', 'time': '', 'datatype': 'Int', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Price', 'columnname': 'price', 'filterby': '=', 'values': '', 'time': '', 'datatype': 'Float', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Order ID', 'columnname': 'orderID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Route ID', 'columnname': 'routedOrderID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Trade ID', 'columnname': 'tradeID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'AllocationID', 'columnname': 'allocationID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Firm Designated ID', 'columnname': 'firmDesignatedID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'File Name', 'columnname': 'fileName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Destination', 'columnname': 'destination', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'GroupName', 'columnname': 'groupName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Order Date', 'columnname': 'orderKeyDate', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
    ];
    this.getData();
    this.getSymbols();

  }

  getSymbols() {
    this.SymbolsArray = [];
    this.CodesArray = [];
    this.isResetGridlimit = true;
    this.gridService.getSymbol(APIURL.QuickFilterFields, this.DefaultFilterArray, this.Limit, "CAT-Exception")
      .subscribe({
        next: (Element:any) => {
        this.SymbolsArray = [];
        this.CodesArray = [];
        let Filter: any = Element;
        this.SymbolsArray = Filter.SymbolList;
        this.CodesArray = Filter.CodeList;
      }, error: (err: HttpErrorResponse) => {
      }});
  }

  getFieldDictionary() {
    this.CATFieldTypesArrayList = this.UserService.getDropDownList('type');
  }

  getData() {
    this.isLoadingResults = true;
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.previousLimit = this.Limit;
    this.dataset1 = [];
    this.selectedTabIndex = 0;
    this.selectedRow = [];
    this.isLoadingResults = true;
    this.tbldatamsg = "L o a d i n g . . . . .";
    this.gridService.getData(
      APIURL.CAT_Exception,
      this.DefaultFilterArray,
      this.Limit,
      this.gridService.getEventsList(this.DefaultFilterArray, 'type'),
      "CAT-Exception"
    ).subscribe({
      next: (Element:any) => {
      this.isLoadingResults = false;
      let dataset: any = Element;
      this.dataset1 = dataset.Data;
      this.dataset1 = this.sortPipe.transform(this.dataset1, this.sortData.order, this.sortData.field);
      this.dataset1.map(element => {
        if(element.originalJSON !== "" && element.originalJSON !== null) {
          let originalJSON = JSON.parse(element.originalJSON);
          if(element.type.startsWith("ML") === true) {
            element['optionalSymbol'] = ((element.underlying) ? element.underlying : ((originalJSON['legDetails'] && originalJSON['legDetails'].length > 0) ? ((originalJSON['legDetails'][0]['symbol']) ? originalJSON['legDetails'][0]['symbol'] : ((originalJSON['legDetails'][0]['optionID']) ? originalJSON['legDetails'][0]['optionID'].split(' ')[0] : '')) : ''));
          }
          element["timeInForce"] = JSON.stringify(originalJSON["timeInForce"]);
          element["handlingInstructions"] = JSON.stringify(originalJSON["handlingInstructions"]);
          element["senderIMID"] = originalJSON["senderIMID"];
        }
      });
      this.defaultData = this.dataset1;
      this.isResetGridlimit = false;
      this.totalRecords = dataset.totalCount;
      this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
      if (this.dataset1.length == 0) {
        this.tbldatamsg = "No data found";
      }
    }, error: (err: HttpErrorResponse) => {
      this.isLoadingResults = false;

    }});
    this.isFilterLabelReset = false;
    this.isResetGridlimit = false;
  }


  setEditRowValue(index: number, key: string) {
    /* Receiving updated TimeInForce Value */
      let timeInForceValue = this.userService.getTimeInforceValue(key, this.Editviewcols[index].field_Name, false, this.Editviewcols);
      this.timeInForceValue = timeInForceValue;
    /* End of Receiving updated TimeInForce Value */

    this.Editviewcols[index].value = {
      [key]: timeInForceValue,
    }
  }
  getObjectKey(obj: {}) {
    const key = Object.keys((obj))[0];
    return key;
  }

  removeNullValueObj(obj: { [x: string]: any; }) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === "" || obj[key] === null) {
        delete obj[key]
      }
    })
    return obj
  }
  getFDID(index: number) {
    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.CAT_Exception_Get_FDID
      ), {
        "mpid": this.userService.getActiveMPID(),
        "givenName": this.givenNameForFDID
      })

      .subscribe({
        next: (data:any) => {
        this.Editviewcols[index].value = data.Data.length > 0 ? data.Data[0].generatedFDID : null;
        if (this.Editviewcols[index].value === null) {
          this.messageService.add({ severity: 'error', summary: 'Not Found', detail: 'Firm Designated ID not found for given name' });
        } else {
          this.messageService.add({ severity: 'success', summary: 'record Found', detail: 'Updated Firm Designated ID' });
        }
      }});
  }
  closeDialog() {
    this.givenNameForFDID = '';
    this.checked = false;
    this.Edit = false;
    this.isClickedOnce = false;
    this.selectedRow = [];
    this.selectedTabIndex = 0;
  }
  exportToCSV(event: { isExportMaxRows: any; gridColumn: any; }) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    if (event.isExportMaxRows) {
      this.Limit = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
     this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    }
    this.gridService.getData(
      APIURL.CAT_Exception,
      this.DefaultFilterArray,
      this.Limit,
      this.gridService.getEventsList(this.DefaultFilterArray, 'type'),
      "CAT-Exception"
    ).subscribe({
      next: (Element:any) => {
      let dataset: any = Element;
      let data = dataset.Data;

      if (data.length > 0) {
        data.forEach((col: { originalJSON: any; }) => {
          delete col.originalJSON;
        });
        const options: any = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title: 'RSMS_CAT_Exception_' + this.userService.getyyyyMMddDateFormate(new Date()),
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
          filename: this.userService.getActiveMPID() +'_RSMS_CAT_Exception_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
        };
        const csvData = this.constantService.getExportData(data, event.gridColumn);
        const csv = generateCsv(options)(csvData);
        const blob = asBlob(options)(csv);
        saveAs(blob,options.filename);
        this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
        this.UserService.logUserActivity('Export CSV', null, {
          'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
        this.UserService.logUserActivity('Export CSV', null, {
          'Text1': 'No data found',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
      this.emitterService.exportToCSVData.emit(true);
    }, error: (err: HttpErrorResponse) => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
      this.UserService.logUserActivity('Export CSV', null, {
        'Text1': 'Error while Exporting',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    }});
  }
  clearValue(row: { isMultiEdited: boolean; }) {
    row.isMultiEdited = true;
    this.clearValueJSON.push(row)
     this.clearValueJSON =  this.clearValueJSON.filter((n, i) =>  this.clearValueJSON.indexOf(n) === i);
  }

  openTree(rowData: any) {
    this.eventTreeService.isDialogOpen = true;
    this.selectedRow = [];
    this.selectedRow[0] = rowData;
  }

  getNumberofLegs(row: any) {
    if(row['originalJSON']) {
      let rawJson = JSON.parse(row['originalJSON']);
      return (rawJson['numberOfLegs'] > 0 ? rawJson['numberOfLegs'] : 0);
    }
  }

  onClickMultiLegEvent(index: any, rowData: any) {
    if (this.selectedRow.length <= 1) {
      this.selectedRow = [];
      this.selectedRow[0] = (rowData)
    }
    this.rowDataforDialog = rowData;
    this.rowIndexForDialog = index;
    this.viewMultiLegEvent = true;
  }

  closeMultiLegEvent() {
    this.viewMultiLegEvent = false;
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  getBooleanValue(value:any){
    let booleanString="";
    if(value==1 || value == 'true')
      booleanString='True'
    if(value==0 || value == 'false')  
      booleanString='False'
    return booleanString;
  }
  sort(event: any) {
    if (this.commonColService.isCtrlPressed|| this.commonColService.isDragging || this.commonColService.selectedFields.length > 1) {
    this.dt.multiSortMeta =[];
    this.dt.sortField = '';
    this.dt.sortOrder = 0;
    return;
  }
    if(this.sortClickCounter !== 3 &&(this.sortData.field === "" ||this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    } 
    if(this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      this.dataset1 = this.sortPipe.transform(this.dataset1, this.sortData.order, this.sortData.field);
    } else {
    this.resetSort()
    }
    
  }

  onAuditTrail(rowData: any) {
    this.isAuditTrail=true;
      this.selectedRow = [];
      this.selectedRow[0] = rowData
  }
  
  resetSort() {
    if(this.dt.multiSortMeta != undefined && this.dt.multiSortMeta?.length > 0) {
    this.dt.multiSortMeta[0].field = '';
    this.dt.multiSortMeta[0].order = 0;
    }

    this.dataset1 = this.defaultData;
   }

  getChildColumns(fieldName:any){
      if(["legDetails"].includes(fieldName)){
        /* Provide Drop Down Field Values to respective Fields (Side/OpenCloseIndicator) */
        if(this.legDetailsCols.length > 0) {
          for(let i=0; i < this.legDetailsCols.length; i++) {
            let Field_Dictionary_Object;
            if(this.legDetailsCols[i]["dropdown"].toLowerCase()==="yes") {
              Field_Dictionary_Object = this.userService.getFieldDictionaryObject(this.legDetailsCols[i]["field"]);
              this.legDetailsCols[i]["dropdownvalue"] = Field_Dictionary_Object.dropdownvalue;
            }
          }
        }

        return this.legDetailsCols;
      } else if (["clientDetails", "firmDetails", "buyDetails", "sellDetails"].includes(fieldName)) {
        /* Provide Drop Down Field Values to respective Fields (Side) */
        if(this.tradeSideDetailsCols.length > 0) {
          for(let i=0; i < this.tradeSideDetailsCols.length; i++) {
            let Field_Dictionary_Object;
            if(this.tradeSideDetailsCols[i]["dropdown"].toLowerCase()==="yes") {
              Field_Dictionary_Object = this.userService.getFieldDictionaryObject(this.tradeSideDetailsCols[i]["field"]);
              this.tradeSideDetailsCols[i]["dropdownvalue"] = Field_Dictionary_Object.dropdownvalue;
              if(this.tradeSideDetailsCols[i]["field"].toLowerCase()==="side") {
                if(this.selectedRow[0]["type"].toLocaleLowerCase().startsWith("me")) {
                  this.tradeSideDetailsCols[i]["dropdownvalue"] = this.tradeSideDetailsCols[i]["dropdownvalue"].filter((rowObj: any) => this.constantService.validSidesMEEventTypes.includes(rowObj.value));
                } else if (this.selectedRow[0]["type"].toLocaleLowerCase().startsWith("mo")) {
                  this.tradeSideDetailsCols[i]["dropdownvalue"] = this.tradeSideDetailsCols[i]["dropdownvalue"].filter((rowObj: any) => this.constantService.validSidesMOEventTypes.includes(rowObj.value));
                }
              }
            }
          }
        }
      }
    return this.tradeSideDetailsCols;
  }

  /* Get Dropdown Values for LegDetails/BuyDetails/SellDetails/FirmDetails/ClientDetails etc. Dropdown Fields */
  getCATDetailsFieldDropdownValues(editRow: any, col: any, tradeSideRowData: any) {
    let fieldOptions = col.dropdownvalue;
      if(["legDetails"].includes(editRow.field_Name)) {
        if(["side"].includes(col.field)) {
          if(tradeSideRowData.symbol && tradeSideRowData.symbol !== null && tradeSideRowData.symbol.length > 0 && (!tradeSideRowData.optionID || tradeSideRowData.optionID === null)) {
            fieldOptions = col.dropdownvalue.filter((rowObj: any) => this.constantService.validSidesMEEventTypes.includes(rowObj.value));
          } else if(tradeSideRowData.optionID && tradeSideRowData.optionID !== null && tradeSideRowData.optionID.length > 0 && (!tradeSideRowData.symbol || tradeSideRowData.symbol === null)) {
            fieldOptions = col.dropdownvalue.filter((rowObj: any) => this.constantService.validSidesMOEventTypes.includes(rowObj.value));
          }
        }
      }
    return fieldOptions;
  }

   onEventTypeChange(e: any) {    
    if(e.value != null && e.value != undefined){
      if (this.selectedRow.length == 1) {
       this.existingEventType= this.selectedRow[0].type;
        this.pageName='CAT-Exception';        
        } else{
        this.selectedID = null;
        this.pageName='CAT-Exception';
        this.selectedFileID = null;
        }
        this.displayNewROEDialog = true;
        this.displayDropdownTypeBySelectedType(this.selectedRow[0]);
    } else{
      this.displayNewROEDialog = false;
    }
  }

  displayDropdownTypeBySelectedType(selectedRecord: FieldDictionary){
    if(selectedRecord == undefined){
      return;
    }       
    let selectedRow1: any = this.dataService.checkRowExistanceInList(selectedRecord, this.selectedRow, 'firmROEID'); // Check Row Object Existance in selected Row Object List
    selectedRow1 = selectedRow1[0];      
    if(selectedRow1 == undefined){
      return;
    }
    this.eventList = [];  
    if(this.selectedRow.length > 1){
      this.eventList = this.constantService.populateEventList("ML");
      return;
    }
    this.selectedID = selectedRow1.firmROEID;
    this.selectedReportDate = selectedRow1.reportDate;
    this.selectedGroupName=selectedRow1.groupName;
    this.selectedFileID = selectedRow1.fileID;
    this.existingEventType = selectedRow1.type;
    this.CATReporterIMID=selectedRow1.CATReporterIMID;
    this.eventList = this.constantService.populateEventList(this.existingEventType);
  }

  getDateTimeTFormate(keyName:any, datetime:any, index:any){
    try {
      this.Editviewcols[index].value = this.userService.getDateTimeTFormate(datetime, keyName);
      if (this.userService.timeStampErrorField == keyName) {
        this.messageService.add({ severity: 'error', summary: 'Invalid DateTime', detail: 'Enter the date and time in as - '+this.userService.getDateTimeTFormatePattern(keyName)+' '+this.Editviewcols[index].value });
      }else{
        if (this.userService.timeStampErrorField === keyName || !this.userService.timeStampErrorField) {
          this.userService.timeStampErrorField = ''; 
        }
      }
    } catch (e) {
      this.userService.timeStampErrorField = keyName;
      this.messageService.add({ severity: 'error', summary: 'Invalid DateTime', detail: 'Enter the date and time in as - '+this.userService.getDateTimeTFormatePattern(keyName)+' '+this.Editviewcols[index].value });
    }
  }

  closeDropdown(e:any){
    this.selectedEventType = null;
    this.displayNewROEDialog = false;
    this.selectedRow = [];
    this.rowDataforDialog = [];
  }

  addCaisDetails(rowData: any) {
    this.displaySideBar = true;
    this.viewFDID = true;
    this.selectedFDIDDetails = rowData;
  }
  onClickCancelFDID() {
    this.viewFDID = false;
    this.displaySideBar = false;
    this.selectedFDIDDetails = {};
  }

  checkErrorcode(failureCode: any, suggestedValue: any) {
    if (this.addCAISFailureCode.includes(failureCode)) {
      return 'Add CAIS in FDID';
    }
    if (this.ViewCAISFailureCode.includes(failureCode)) {
      return 'View CAIS in FDID';
    }
    return suggestedValue;
  }
  openDetails(rowData: any) {
    if (this.addCAISFailureCode.includes(rowData['failureCode'])) {
      if (rowData.actualValue && rowData.actualValue != "" && rowData.actualValue.trim() != "") {
        this.addCaisDetails(rowData);
      }
      else {
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Actual value for FDID is not present' });
      }
    }
    if (this.ViewCAISFailureCode.includes(rowData['failureCode'])) {
      if (rowData.firmDesignatedID && rowData.firmDesignatedID != "" && rowData.firmDesignatedID.trim() != "") {
        this.viewCaisDetails(rowData);
      }
      else {
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Actual value for FDID is not present' });
      }
    }
  }
  viewCaisDetails(rowData: any) {
    let urlParams = {
      "firmDesignatedID": rowData.firmDesignatedID
    };

    /* Catch User Action Log */
      this.userService.logUserActivity("Reviewed CAIS-FDID Records", null, {
        'Text1': this.userService.userFirstName + ' reviewed CAIS-FDID records from CAT-Exceptions',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(urlParams)
      });

    this.router.navigate([]).then(result => { window.open('#/Rsms/pages/CAIS/FDID?mode=View&FDIDData=' + btoa(JSON.stringify(urlParams))) });
  }

}